/**
 * Реестр платёжных провайдеров (ARCH-TASK-65.12.6).
 *
 * Ядро работает только с реестром: модули регистрируют провайдеров в
 * composition root (`bootstrap.ts`) по юрисдикции, UI берёт провайдера по
 * способу оплаты и не импортирует плагины.
 */
import type {
  PaymentProvider,
  PaymentUiResolver
} from './types';

export class PaymentRegistry {
  private readonly providers = new Map<string, PaymentProvider>();
  private resolver: PaymentUiResolver | null = null;

  /** Зарегистрировать провайдера (повторный id — предупреждение и игнор). */
  register(provider: PaymentProvider): this {
    if (this.providers.has(provider.id)) {
      console.warn(`[payments] провайдер "${provider.id}" уже зарегистрирован — игнор`);
      return this;
    }
    this.providers.set(provider.id, provider);
    return this;
  }

  /** Все зарегистрированные провайдеры (для статус-индикаторов). */
  list(): PaymentProvider[] {
    return [...this.providers.values()];
  }

  get(id: string): PaymentProvider | undefined {
    return this.providers.get(id);
  }

  /** Поддерживается ли способ оплаты хотя бы одним провайдером. */
  supports(method: string): boolean {
    for (const provider of this.providers.values()) {
      if (provider.supports(method)) return true;
    }
    return false;
  }

  /** Найти провайдера под способ оплаты. */
  providerFor(method: string): PaymentProvider | undefined {
    for (const provider of this.providers.values()) {
      if (provider.supports(method)) return provider;
    }
    return undefined;
  }

  /**
   * UI-резолвер один на приложение: его вызывает провайдер, когда нужно
   * показать QR покупателю и дождаться исхода.
   */
  setResolver(resolver: PaymentUiResolver | null): void {
    this.resolver = resolver;
  }

  getResolver(): PaymentUiResolver | null {
    return this.resolver;
  }
}
